import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DebugIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Debug",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2m12 14v.02c0 2.96-1.08 5.66-2.86 7.74v-.02l-5.25-5.27L21 17.36c.72.48 1.6.77 2.55.77h.17c.45 0 .9-.05 1.32-.14H25c.46-.11.79-.51.79-.99a1.03 1.03 0 0 0-1.28-1c-.25.06-.53.09-.83.09-.51 0-1-.1-1.45-.29h.02c.37-.63.59-1.4.59-2.23 0-.43-.06-.84-.17-1.24v.03h.9c.55 0 1-.45 1-1s-.45-1-1-1h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v.93c-.36-.11-.78-.17-1.21-.17-.81 0-1.57.21-2.22.59h.02c-.17-.43-.28-.91-.28-1.41 0-.3.03-.59.1-.86v.03c.01-.07.02-.15.02-.24a1 1 0 0 0-.75-.97 1 1 0 0 0-.29-.05c-.48 0-.87.33-.98.78a5.537 5.537 0 0 0 .62 4.03v-.03l-.48.48-.64.63-5.24-5.26c2.07-1.76 4.78-2.83 7.74-2.83 6.62 0 11.99 5.36 12 11.98ZM4 16c0-2.96 1.07-5.66 2.85-7.75v.02L10 11.44c-.48.07-.85.49-.85.99v.01a1 1 0 0 0 1 .95h.06c.6 0 1.16.14 1.67.39h-.02l-1.35 1.33c-.74-.39-1.61-.61-2.54-.61-.46 0-.91.06-1.33.16h.04c-.42.12-.72.5-.72.95 0 .55.45 1 1 1 .07 0 .14 0 .21-.02.25-.06.54-.09.83-.09.49 0 .95.09 1.38.26h-.03c-.38.65-.61 1.44-.61 2.28 0 1.18.44 2.25 1.18 3.07.81.72 1.88 1.17 3.06 1.17.81 0 1.57-.21 2.22-.58h-.02c.17.42.28.9.28 1.4q0 .42-.09.81v-.02c-.01.07-.02.15-.02.24a1 1 0 0 0 .75.97s.24 0 .24 0h.03a1 1 0 0 0 .97-.75c.1-.4.15-.84.15-1.3 0-.93-.23-1.8-.63-2.57v.03h.06l1.34-1.35c.24.48.38 1.04.38 1.63v.07c0 .53.41.96.93 1h.08c.5 0 .91-.37.99-.84s3.17 3.15 3.17 3.15a11.94 11.94 0 0 1-7.8 2.88c-6.63 0-12-5.37-12-12V16Z"
    })
  }));
};